var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        scrollable: "",
        title: _vm.il8Title,
        width: "1024px",
        styles: _vm.modalStyle,
      },
      on: { "on-cancel": _vm.$_cancel },
      model: {
        value: _vm.showpick,
        callback: function ($$v) {
          _vm.showpick = $$v
        },
        expression: "showpick",
      },
    },
    [
      _c("div", { staticClass: "emap-flow-pick" }, [
        _c(
          "div",
          { staticClass: "emap-flow-search" },
          [
            _c("Input", {
              attrs: {
                type: "text",
                placeholder: _vm.il8Placeholder,
                "enter-button": _vm.$LocalH5("search"),
                search: "",
              },
              on: { "on-search": _vm.$_search },
              model: {
                value: _vm.searchkey,
                callback: function ($$v) {
                  _vm.searchkey = typeof $$v === "string" ? $$v.trim() : $$v
                },
                expression: "searchkey",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "emap-flow-main clearfix" }, [
          _c(
            "div",
            { staticClass: "emap-flow-left" },
            [
              _c(
                "Tabs",
                { attrs: { value: "tabX", animated: false } },
                [
                  _c(
                    "TabPane",
                    {
                      attrs: {
                        label: _vm.$LocalH5("organization"),
                        name: "tabX",
                      },
                    },
                    [
                      _c("Tree", {
                        ref: "tree",
                        staticClass: "emap-flow-left-tree",
                        attrs: {
                          data: _vm.treeData,
                          "empty-text": _vm.$LocalH5("noData"),
                          "show-checkbox": _vm.filter && _vm.multiple,
                        },
                        on: {
                          "on-select-change": _vm.$_treeItemCheck,
                          "on-check-change": _vm.$_filterItemCheck,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "emap-flow-center" }, [
            _c("div", { staticClass: "emap-flow-center-header" }, [
              _c("span", [_vm._v(_vm._s(_vm.$LocalH5("waitPersonnel")))]),
              _vm._v(" "),
              _c("span", { staticClass: "emap-flow-center-count" }, [
                _vm._v(_vm._s(_vm.staff.length)),
              ]),
            ]),
            _vm._v(" "),
            !_vm.staff.length
              ? _c("div", { staticClass: "emap-flow-nodata" }, [
                  _vm._v(_vm._s(_vm.$LocalH5("noData"))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.staff.length
              ? _c(
                  "div",
                  { staticClass: "emap-flow-center-body" },
                  [
                    _c("table", { staticStyle: { width: "100%" } }, [
                      _c("thead", [
                        _c("tr", { staticStyle: { height: "30px" } }, [
                          _c(
                            "th",
                            {
                              staticClass: "emap-flow-col1",
                              staticStyle: { "text-align": "center" },
                            },
                            [
                              _vm.multiple
                                ? _c("Checkbox", {
                                    staticStyle: { "margin-right": "4px" },
                                    attrs: { disabled: !_vm.staff.length },
                                    on: { "on-change": _vm.$_allCheck },
                                    model: {
                                      value: _vm.isCheckedAll,
                                      callback: function ($$v) {
                                        _vm.isCheckedAll = $$v
                                      },
                                      expression: "isCheckedAll",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("th", { staticClass: "emap-flow-col3" }, [
                            _vm._v(_vm._s(_vm.$LocalH5("name"))),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "emap-flow-col3" }, [
                            _vm._v(_vm._s(_vm.$LocalH5("numId"))),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "emap-flow-col3" }, [
                            _vm._v(_vm._s(_vm.$LocalH5("org"))),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    !_vm.multiple
                      ? _c(
                          "div",
                          { staticClass: "emap-flow-radio-list" },
                          [
                            _c(
                              "RadioGroup",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { vertical: "" },
                                model: {
                                  value: _vm.raidoValue,
                                  callback: function ($$v) {
                                    _vm.raidoValue = $$v
                                  },
                                  expression: "raidoValue",
                                },
                              },
                              _vm._l(_vm.staff, function (item) {
                                return _c(
                                  "Radio",
                                  {
                                    key: item.id,
                                    staticClass: "emap-flow-radio-item",
                                    attrs: { label: item.id },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "emap-flow-col3",
                                        attrs: { title: item.name },
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "emap-flow-col3",
                                        attrs: { title: item.encodeId },
                                      },
                                      [_vm._v(_vm._s(item.encodeId))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "emap-flow-col3",
                                        attrs: { title: item.deptName },
                                      },
                                      [_vm._v(_vm._s(item.deptName))]
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.multiple
                      ? _c(
                          "div",
                          { staticClass: "emap-flow-checkbox-list" },
                          [
                            _c(
                              "CheckboxGroup",
                              {
                                model: {
                                  value: _vm.checkboxValue,
                                  callback: function ($$v) {
                                    _vm.checkboxValue = $$v
                                  },
                                  expression: "checkboxValue",
                                },
                              },
                              _vm._l(_vm.staff, function (item) {
                                return _c(
                                  "Checkbox",
                                  {
                                    key: item.id,
                                    staticClass: "emap-flow-checkbox-item",
                                    attrs: {
                                      label: item.id,
                                      disabled:
                                        _vm.disabledOptions.indexOf(item.id) >
                                        -1,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.$_checkboxItemCheck(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "emap-flow-col3",
                                        attrs: { title: item.name },
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "emap-flow-col3",
                                        attrs: { title: item.encodeId },
                                      },
                                      [_vm._v(_vm._s(item.encodeId))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "emap-flow-col3",
                                        attrs: { title: item.deptName },
                                      },
                                      [_vm._v(_vm._s(item.deptName))]
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("Page", {
                      staticClass: "emap-flow-page",
                      attrs: {
                        current: _vm.pageNumber,
                        total: _vm.total,
                        simple: "",
                      },
                      on: { "on-change": _vm.$_pageChange },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "emap-flow-right" }, [
            _c("div", { staticClass: "emap-flow-right-header" }, [
              _c("span", [_vm._v(_vm._s(_vm.$LocalH5("selectedPersonnel")))]),
              _vm._v(" "),
              _c("span", { staticClass: "emap-flow-right-count" }, [
                _vm._v(_vm._s(_vm.checkedStaff.length)),
              ]),
            ]),
            _vm._v(" "),
            _vm.checkedStaff.length
              ? _c("div", { staticClass: "emap-flow-right-body" }, [
                  _c("table", { staticStyle: { width: "100%" } }, [
                    _c("thead", [
                      _c("tr", { staticStyle: { height: "30px" } }, [
                        _c("th", { staticClass: "emap-flow-col3" }, [
                          _vm._v(_vm._s(_vm.$LocalH5("name"))),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "emap-flow-col3" }, [
                          _vm._v(_vm._s(_vm.$LocalH5("numId"))),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "emap-flow-col3" }, [
                          _vm._v(_vm._s(_vm.$LocalH5("org"))),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "emap-flow-col1" }, [
                          _vm._v(_vm._s(_vm.$LocalH5("delete"))),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "emap-flow-checked-list" },
                    _vm._l(_vm.checkedStaff, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "emap-flow-checked-item clearfix",
                          class: [
                            {
                              "emap-flow-disabled":
                                _vm.disabledOptions.indexOf(item.id) > -1,
                            },
                          ],
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "emap-flow-col3",
                              attrs: { title: item.name || item.userName },
                            },
                            [_vm._v(_vm._s(item.name || item.userName))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "emap-flow-col3",
                              attrs: { title: item.encodeId || item.userId },
                            },
                            [_vm._v(_vm._s(item.encodeId || item.userId))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "emap-flow-col3",
                              attrs: { title: item.deptName },
                            },
                            [_vm._v(_vm._s(item.deptName))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "emap-flow-col1",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  _vm.$_deleteRecords(
                                    item,
                                    index,
                                    _vm.disabledOptions.indexOf(item.id) > -1
                                  )
                                },
                              },
                            },
                            [
                              _c("Icon", {
                                attrs: { type: "md-trash", size: "16" },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "Button",
            { attrs: { size: "large" }, on: { click: _vm.$_cancel } },
            [_vm._v(_vm._s(_vm.$LocalH5("buttonCancel")))]
          ),
          _vm._v(" "),
          _c(
            "Button",
            {
              attrs: { type: "primary", size: "large" },
              on: { click: _vm.$_confirm },
            },
            [_vm._v(_vm._s(_vm.$LocalH5("buttonConfirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }